import React from 'react';
import styled from 'styled-components';

import { useAppSelector } from '@/hooks';
import { LargeLoader } from '@/components/common';
import { Z_INDEX_FULLSCREEN_LOADER } from '@/config/variables';

interface IProps {
  show?: boolean;
}

const FullscreenLoader = ({ show }: IProps): React.ReactElement => {
  const { showFullscreenLoader } = useAppSelector(state => state.utils);

  const showLoader = showFullscreenLoader || show;

  return (
    <>
      {showLoader && (
        <Container>
          <LargeLoader />
        </Container>
      )}
    </>
  );
};

export { FullscreenLoader };

const Container = styled.div`
  position: absolute;
  z-index: ${Z_INDEX_FULLSCREEN_LOADER};
  display: flex;
  align-items: flex-end;
  height: 100vh;
  background-color: #ffffff;
`;
